import type { Certificate } from "../../../shared/models/certificate";
import type { BulkRevocationResponse } from "../../../shared/models/bulk_revocation";
import { createDataStore } from "../lib/data_store";
import { post } from "aws-amplify/api";
import { API_NAME } from "../lib/amplify";
import { extractApiError } from "../lib/api_error";
import { listAccountData } from "./account_store";

const certificateStore = createDataStore<Certificate[] | undefined>();

export const useCertificates = certificateStore.useDataSuspense;
export const setCertificates = certificateStore.setData;

interface RevokeCertificateResponse {
  deviceId: string;
  revokedAt: string;
}

export async function revokeCertificate(
  deviceId: string,
  certvalidfrom: string
): Promise<void> {
  let data: RevokeCertificateResponse;
  try {
    const { body } = await post({
      apiName: API_NAME,
      path: "/revoke-certificate",
      options: { body: { deviceId, certvalidfrom } },
    }).response;
    data = (await body.json()) as unknown as RevokeCertificateResponse;
  } catch (err) {
    throw new Error(await extractApiError(err));
  }

  certificateStore.updateData((current) =>
    (current ?? []).map((certificate) =>
      certificate.deviceId === data.deviceId
        ? {
            ...certificate,
            status: "revoked",
            revokedAt: data.revokedAt,
          }
        : certificate
    )
  );
}

export async function bulkRevokeCertificates(
  certificates: { deviceId: string; certvalidfrom: string }[]
): Promise<BulkRevocationResponse> {
  let data: BulkRevocationResponse;
  try {
    const { body } = await post({
      apiName: API_NAME,
      path: "/bulk-revoke-certificates",
      options: { body: { certificates } },
    }).response;
    data = (await body.json()) as unknown as BulkRevocationResponse;
  } catch (err) {
    throw new Error(await extractApiError(err));
  }

  await listAccountData();
  return data;
}
